const initialState = {
  gailResponse: null,
  emailResponse:{},
  error: null,
};

const gailReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GAIL_SUCCESS":
      return { ...state, gailResponse: action.payload, error: null };
     case "VERIFY_EMAIL_SUCCESS":
      return { ...state, emailResponse: action.payload, error: null };
    case "GAIL_FAILURE":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default gailReducer;
